/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import {
    Card, Checkbox,
    Col,
    Form,
    Radio,
    Row,
} from 'antd';
import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

//const { Option } = Select;
const WeldingForm = (props) => {

    const {
        Specification,
        partsData,
        setPartsData,
        activeLine,
        weldingData,
        isEdit
    } = props;


    const [selectedOptions, setSelectedOptions] = useState({
        m_Series: [],
        M500: {
            Process: "", // FCAW or STT
            Manufacturer: "" // MILLER or LINCOLN (only if Process is FCAW)
        },
        M400: {
            Process: "", // STT
            Manufacturer: "" // MILLER or LINCOLN
        },
        P600: "",
        P625: {
            P_625: "",
            Torch: "",
            CMT_Torch: "",
            CMT_Material: "",
            CMT_Wire_Size: ""
        },
        ManualRepairs: {
            enabled: false,
            options: [] // MMA, GTAW, FCAW
        },
        ManualFullScope: {
            enabled: false,
            options: [] // MMA, GTAW, FCAW
        }
    });

    useEffect(() => {

        if (isEdit && weldingData) {
            const data = weldingData[activeLine]?.Welding
            // console.log('weldingData', isEdit, data, selectedOptions)

            if (isEdit && data) {
                setSelectedOptions(prevState => ({
                    ...prevState,
                    m_Series: data.m_Series ? data.m_Series.split(',') : [],
                    M500: {
                        Process: data.M500_Process || "",
                        Manufacturer: data.M500_Manufacturer || ""
                    },
                    M400: {
                        Process: data.M400_Process || "",
                        Manufacturer: data.M400_Manufacturer || ""
                    },
                    P600: data.P600 || "",
                    P625:
                    {
                        P_625: data.P_625,
                        Torch: data.Torch,
                        CMT_Torch: data.CMT_Torch,
                        CMT_Material: data.CMT_Material,
                        CMT_Wire_Size: data.CMT_Wire_Size
                    },
                    ManualRepairs: {
                        enabled: data.ManualRepairs ? data.ManualRepairs.split(',').length > 0 : false,
                        options: data.ManualRepairs ? data.ManualRepairs.split(',') : []
                    },
                    ManualFullScope: {
                        enabled: data.ManualFullScope ? data.ManualFullScope.split(',').length > 0 : false,
                        options: data.ManualFullScope ? data.ManualFullScope.split(',') : []
                    }
                }));
            }
        }

    }, [weldingData, activeLine, Specification])

    useEffect(() => {
        if (Specification) {
            setPartsData((prevOptions) => {


                return {
                    ...prevOptions,
                    [`Line_${activeLine + 1}`]: {
                        ...prevOptions[`Line_${activeLine + 1}`],
                        WeldingData: selectedOptions
                    }
                };
            });
            // console.log(selectedOptions);
            // Update the state or perform any other actions with the updated partsData
        }
    }, [selectedOptions, Specification, activeLine]);

    const handleCheckboxChange = (category, checkedValues) => {
        setSelectedOptions((prevOptions) => {
            if (category === 'ManualRepairs' || category === 'ManualFullScope') {
                return {
                    ...prevOptions,
                    [category]: {
                        ...prevOptions[category],
                        options: checkedValues,
                        enabled: checkedValues.length > 0
                    }
                };
            }
            return {
                ...prevOptions,
                [category]: checkedValues,
            };
        });
    };
    const handleHeaderCheckboxChange = (category, isChecked, value) => {
        // console.log(category, isChecked, selectedOptions);
        setSelectedOptions(prevOptions => {
            if (isChecked) {
                // Add values when the header checkbox is checked
                return {
                    ...prevOptions,
                    [category]: value,
                };
            } else {
                // Remove values when the header checkbox is unchecked
                return {
                    ...prevOptions,
                    [category]: typeof prevOptions[category] === 'object' && !Array.isArray(prevOptions[category]) ? {} : (Array.isArray(prevOptions[category]) ? [] : ''),
                };
            }
        });
    };

    const handleCheckboxChange1 = (category, type, checkedValues) => {


        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: checkedValues,
                },
            };
        });
    };
    const updateP625Value = (category, isChecked) => {
        setSelectedOptions((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };

            if (!isChecked && category == 'P625') {

                // If the checkbox is unchecked, clear the values for those types
                updatedCategory['P_625'] = '';
                updatedCategory['Torch'] = ''; // Clear value
                updatedCategory['CMT_Torch'] = ''; // Clear value
                updatedCategory['CMT_Material'] = ''; // Clear value
                updatedCategory['CMT_Wire_Size'] = ''; // Clear value
            }

            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });

    }
    const handleHeaderCheckboxChange1 = (category, type, isChecked, value) => {

        setSelectedOptions((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };

            if (isChecked) {
                // Add values when the header checkbox is checked
                if (!isArrayNotEmpty(category, type))
                    updatedCategory[type] = value;
            }
            else {
                updatedCategory[type] = '';
            }

            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });
    }

    const handleRadioChange = (category, type, value) => {
        if (!getCategoryValue1('P625', 'CMT_Torch') || !getCategoryValue1('P625', 'CMT_Material') || !!getCategoryValue1('P625', 'CMT_Wire_Size')) {
            handleHeaderCheckboxChange1('P625', 'CMT_Torch', isArrayNotEmpty('P625', "P_625"), 'F-ORIG')
            handleHeaderCheckboxChange1('P625', 'CMT_Material', isArrayNotEmpty('P625', "P_625"), 'CS')
            handleHeaderCheckboxChange1('P625', 'CMT_Wire_Size', isArrayNotEmpty('P625', "P_625"), '1.0')
        }
        setSelectedOptions((prevOptions) => {

            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: value,
                },
            };

        });
        // console.log(category, value, selectedOptions)
    };

    const handleTorchRadioChange = (category, type, value) => {

        setSelectedOptions((prevOptions) => {

            return {
                ...prevOptions,
                [category]: {
                    ...prevOptions[category],
                    [type]: value,
                },
            };

        });
        // console.log(category, value, selectedOptions)
    };


    const isArrayNotEmpty = (category, type) => {
        return (
            selectedOptions.hasOwnProperty(category) && // Check if the category exists in selectedOptions
            selectedOptions[category][type] != '' // Check if the array is not empty
        );
    };
    const isArrayNotEmpty1 = (category, type) => {
        return selectedOptions[category] && Array.isArray(selectedOptions[category][type]) && selectedOptions[category][type].length > 0;
    };

    const getCategoryValue = (category) => {
        if (selectedOptions.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return selectedOptions[category]; // Return the value for the category
        } else {
            return null; // Return null if the category does not exist
        }
    };
    const getCategoryValue1 = (category, type) => {
        if (selectedOptions.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            if (selectedOptions[category] && typeof selectedOptions[category] === 'object' && !Array.isArray(selectedOptions[category])) {
                return selectedOptions[category][type] || null; // Return the value for the category
            }
            return null;
        } else {
            return null; // Return null if the category does not exist
        }
    };
    const isArrayContainValue1 = (category, type) => {
        return (
            selectedOptions[category] &&
                Array.isArray(selectedOptions[category][type])
                ? selectedOptions[category][type]
                : []
        );
    };
    const isAnyPropertyWithValue = () => {
        return (

            isArrayNotEmpty('P625', 'CMT_Torch') || isArrayNotEmpty('P625', 'CMT_Material') ||
            isArrayNotEmpty('P625', 'CMT_Wire_Size')
        );
    };

    const handleM500ProcessChange = (value) => {
        setSelectedOptions((prevOptions) => {
            const updatedM500 = { ...prevOptions.M500 };
            updatedM500.Process = value;
            // Clear Manufacturer when process changes, user will select again
            updatedM500.Manufacturer = '';
            return {
                ...prevOptions,
                M500: updatedM500
            };
        });
    };

    const handleM500ManufacturerChange = (value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                M500: {
                    ...prevOptions.M500,
                    Manufacturer: value
                }
            };
        });
    };

    const handleM400ProcessChange = (value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                M400: {
                    ...prevOptions.M400,
                    Process: value
                }
            };
        });
    };

    const handleM400ManufacturerChange = (value) => {
        setSelectedOptions((prevOptions) => {
            return {
                ...prevOptions,
                M400: {
                    ...prevOptions.M400,
                    Manufacturer: value
                }
            };
        });
    };

    const isM500Selected = () => {
        return getCategoryValue('m_Series')?.includes('M-500');
    };

    const isM400Selected = () => {
        return getCategoryValue('m_Series')?.includes('M-400');
    };

    return (


        <div className="pipeline-modal">

            <div style={{ marginTop: '-10px' }}>
                <Row justify="start">
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="mb-0" style={{ fontSize: '18px' }}>Specification :</p>

                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">Pipe Size(inch)</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col1}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">Wall Thickness(mm)</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col2}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">No. of Welds</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col3}</p>
                            </div>
                        </div>
                    </Col>
                    <Col span={4}>
                        <div className="project-details-wrapper text-center">
                            <p className="fw-medium title">No. of Station</p>
                            <div className="d-flex edit-session justify-content-center mb-3">
                                <p className="mb-0">{Specification.col4}</p>
                            </div>
                        </div>
                    </Col>



                </Row>
            </div>
            <div className="custom-line" style={{ marginTop: '-10px' }} />
            <Form

                name="basic"
                autoComplete="off"
                width='100%'
                style={{ marginTop: '-10px' }}
            >



                <Card className="custom-card2" title="EWM" style={{ background: 'rgba(255, 255, 255, 0.1)', minHeight: '500px', fontSize: '20px' }}>
                    <Row gutter={24}>
                        {/* Left Column - Main Options */}
                        <Col lg={4}>
                            <Checkbox.Group style={{ display: 'grid', fontSize: '10px' }} value={getCategoryValue('m_Series')}
                                onChange={(checkedValues) => handleCheckboxChange('m_Series', checkedValues)}>
                                <Checkbox style={{ fontSize: '18px' }} value='M-500'>M-500</Checkbox>
                                <Checkbox style={{ fontSize: '18px', marginLeft: '-0px', paddingTop: '20px' }} value='M-400'>M-400</Checkbox>
                                <Checkbox style={{ fontSize: '18px', marginLeft: '-0px', paddingTop: '20px' }} value='M-300'>M-300</Checkbox>
                            </Checkbox.Group>

                            <div style={{ display: 'grid', fontSize: '10px', paddingTop: '20px' }} className='report-radio'>
                                <Checkbox style={{ fontSize: '18px', marginLeft: '-0px' }} checked={selectedOptions.P600 !== '' && selectedOptions.P600 !== null && selectedOptions.P600 !== undefined}
                                    onChange={(e) => handleHeaderCheckboxChange('P600', e.target.checked, 'P-600')}>P-600</Checkbox>
                            </div>

                            <div style={{ display: 'grid', fontSize: '10px', paddingTop: '20px' }} className='report-radio'>
                                <Checkbox style={{ fontSize: '18px', marginLeft: '-0px' }} checked={isArrayNotEmpty('P625', "P_625")}
                                    onChange={(e) => {
                                        updateP625Value("P625", e.target.checked)
                                        handleHeaderCheckboxChange1('P625', 'P_625', e.target.checked, 'P-625')
                                        handleHeaderCheckboxChange1('P625', 'Torch', e.target.checked, 'Single Torch')
                                    }
                                    }>P625</Checkbox>
                            </div>



                        </Col>

                        {/* Middle Column - Process and Manufacturer Selection */}
                        <Col lg={12}>
                            {/* M-500 Flow */}
                            {isM500Selected() && (
                                <div style={{ paddingBottom: '30px' }}>
                                    <Form.Item style={{ paddingTop: '0px', paddingLeft: '0px', cursor: 'default' }}
                                        label='Process Type:'
                                        className='report-radio'
                                    >
                                        <Radio.Group
                                            style={{ display: "flex" }}
                                            value={getCategoryValue1('M500', 'Process')}
                                            onChange={(e) => handleM500ProcessChange(e.target.value)}
                                        >
                                            <Radio value='FCAW'>FCAW</Radio>
                                            <Radio value='STT'>STT</Radio>
                                        </Radio.Group>
                                    </Form.Item>

                                    {getCategoryValue1('M500', 'Process') === 'FCAW' && (
                                        <Form.Item style={{ paddingTop: '-10px', paddingLeft: '0px', cursor: 'default' }}
                                            label='Manufacturer:'
                                            className='report-radio'
                                        >
                                            <Radio.Group
                                                style={{ display: "flex" }}
                                                value={getCategoryValue1('M500', 'Manufacturer')}
                                                onChange={(e) => handleM500ManufacturerChange(e.target.value)}
                                            >
                                                <Radio value='MILLER'>MILLER</Radio>
                                                <Radio value='LINCOLN'>LINCOLN</Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    )}
                                </div>
                            )}


                            {/* P625 Section */}
                            {isArrayNotEmpty('P625', "P_625") && (
                                <div style={{ display: 'grid', fontSize: '10px' }} className='report-radio'>
                                    <Form.Item style={{ paddingTop: '0px', paddingLeft: '0px', cursor: 'default' }}
                                        label='Torch Type:'
                                        className='report-radio'
                                    >
                                        <Radio.Group style={{ display: "flex" }} value={getCategoryValue1('P625', 'Torch')}
                                            onChange={(e) => handleTorchRadioChange('P625', 'Torch', e.target.value)} >
                                            <Radio value='Single Torch'>Single </Radio>
                                            <Radio value='Dual Torch'>Dual</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    <div style={{ display: 'grid', fontSize: '10px', paddingLeft: '80px' }}>
                                        <Checkbox style={{ fontSize: '18px' }} checked={isAnyPropertyWithValue()}
                                            onChange={(e) => {
                                                handleHeaderCheckboxChange1('P625', 'CMT_Torch', e.target.checked, 'F-ORIG')
                                                handleHeaderCheckboxChange1('P625', 'CMT_Material', e.target.checked, 'CS')
                                                handleHeaderCheckboxChange1('P625', 'CMT_Wire_Size', e.target.checked, '1.0')
                                            }} >CMT</Checkbox>

                                        <Form.Item style={{ paddingTop: '10px', paddingLeft: '20px', cursor: 'default' }}
                                            label='Torch:'
                                            className='report-radio'
                                        >
                                            <div style={{ flexDirection: 'column', paddingTop: '5px' }}>
                                                <Radio.Group style={{ display: "flex" }} onChange={(e) => handleRadioChange('P625', "CMT_Torch", e.target.value)}
                                                    value={getCategoryValue1('P625', 'CMT_Torch')}>
                                                    <Radio value='F-ORIG' >Fronius original</Radio>
                                                    <Radio value='F-NEW' >Fronius New</Radio>
                                                    <Radio value='EWS' >European welding supplies </Radio>
                                                </Radio.Group>
                                            </div>
                                        </Form.Item>
                                        <Form.Item style={{ paddingTop: '0px', paddingLeft: '20px', cursor: 'default' }}
                                            label='Material:'
                                            className='report-radio'
                                        >
                                            <div style={{ display: 'grid', fontSize: '10px' }} className='report-radio'>
                                                <>
                                                    <Radio.Group style={{ display: "flex" }} onChange={(e) => handleRadioChange('P625', "CMT_Material", e.target.value)}
                                                        value={getCategoryValue1('P625', "CMT_Material")}>
                                                        <Radio value='CS'>Carbon steel</Radio>
                                                        <Radio value='SS' >Stainless steel</Radio>
                                                    </Radio.Group>
                                                </>
                                            </div>
                                        </Form.Item>
                                        <Form.Item style={{ paddingTop: '0px', paddingLeft: '20px', cursor: 'default' }}
                                            label='Wire size:'
                                            className='report-radio'
                                        >
                                            <div style={{ flexDirection: 'column', paddingTop: '00px' }}>
                                                <Radio.Group style={{ display: "flex" }}
                                                    onChange={(e) => handleRadioChange('P625', "CMT_Wire_Size", e.target.value)} value={getCategoryValue1('P625', "CMT_Wire_Size")}
                                                >
                                                    <Radio value='1.0' >1.0</Radio>
                                                    <Radio value='1.2'>1.2</Radio>
                                                </Radio.Group>
                                            </div>
                                        </Form.Item>
                                    </div>
                                </div>
                            )}
                        </Col>

                        {/* Right Column - Manual Options */}
                        <Col lg={8}>
                            <div style={{ display: 'grid', fontSize: '10px' }}>
                                <Checkbox
                                    style={{ fontSize: '18px', marginBottom: '10px' }}
                                    checked={selectedOptions.ManualRepairs?.enabled || false}
                                    onChange={(e) => {
                                        setSelectedOptions((prevOptions) => ({
                                            ...prevOptions,
                                            ManualRepairs: {
                                                enabled: e.target.checked,
                                                options: e.target.checked ? (prevOptions.ManualRepairs?.options || []) : []
                                            }
                                        }));
                                    }}
                                >Manual Repairs</Checkbox>

                                {selectedOptions.ManualRepairs?.enabled && (
                                    <div style={{ paddingLeft: '25px', marginTop: '5px' }}>
                                        <Radio.Group
                                            style={{ display: "flex" }}
                                            value={selectedOptions.ManualRepairs?.options && selectedOptions.ManualRepairs.options.length > 0 ? selectedOptions.ManualRepairs.options[0] : null}
                                            onChange={(e) => handleCheckboxChange('ManualRepairs', [e.target.value])}
                                        >
                                            <Radio value='MMA'>MMA</Radio>
                                            <Radio value='GTAW'>GTAW</Radio>
                                            <Radio value='FCAW'>FCAW</Radio>
                                        </Radio.Group>
                                    </div>
                                )}
                            </div>
                            
                            <div style={{ display: 'grid', fontSize: '10px', paddingTop: '20px' }}>
                                <Checkbox
                                    style={{ fontSize: '18px', marginBottom: '10px' }}
                                    checked={selectedOptions.ManualFullScope?.enabled || false}
                                    onChange={(e) => {
                                        setSelectedOptions((prevOptions) => ({
                                            ...prevOptions,
                                            ManualFullScope: {
                                                enabled: e.target.checked,
                                                options: e.target.checked ? prevOptions.ManualFullScope?.options || [] : []
                                            }
                                        }));
                                    }}
                                >Manual Full Scope</Checkbox>

                                {selectedOptions.ManualFullScope?.enabled && (
                                    <div style={{ paddingRight: '180px', marginTop: '5px' }}>
                                        <Checkbox.Group 
                                            value={selectedOptions.ManualFullScope?.options || []}
                                            onChange={(checkedValues) => handleCheckboxChange('ManualFullScope', checkedValues)}
                                        >
                                            <Checkbox value='MMA'>MMA</Checkbox>
                                            <Checkbox value='GTAW'>GTAW</Checkbox>
                                            <Checkbox value='FCAW'>FCAW</Checkbox>
                                        </Checkbox.Group>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Form>


        </div>
    );
};



export default connect(null, null)(WeldingForm);

